import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { Fragment } from "react";

type LanguageDropdownOptionProps<T> = { className?: string; children?: React.ReactNode } & Omit<
    Headless.ListboxOptionProps<"div", T>,
    "as" | "className"
>;

const LanguageDropdownOption = <T,>({ children, className, ...props }: LanguageDropdownOptionProps<T>) => {
    const sharedClasses = clsx(
        "flex gap-1 min-w-0 items-center",
        "*:data-[slot=icon]:size-5 *:data-[slot=icon]:shrink-0 sm:*:data-[slot=icon]:size-4",
        "*:data-[slot=icon]:text-zinc-500 group-data-focus/option:*:data-[slot=icon]:text-white",
        "forced-colors:*:data-[slot=icon]:text-[CanvasText] forced-colors:group-data-focus/option:*:data-[slot=icon]:text-[Canvas]",
        "*:data-[slot=avatar]:-mx-0.5 *:data-[slot=avatar]:size-6 sm:*:data-[slot=avatar]:size-5"
    );

    return (
        <Headless.ListboxOption as={Fragment} {...props}>
            {({ selectedOption }) => {
                if (selectedOption) {
                    return <div className={clsx(className, sharedClasses)}>{children}</div>;
                }

                return (
                    <div
                        className={clsx(
                            "group/option p-2 cursor-pointer items-baseline rounded-lg",
                            "text-base font-medium text-gray-900 hover:underline"
                        )}
                    >
                        <div className={clsx(className, sharedClasses)}>{children}</div>
                    </div>
                );
            }}
        </Headless.ListboxOption>
    );
};

export default LanguageDropdownOption;
